<template>
	<div id="app" class="container-fluid">
		<router-view/>
	</div>
</template>

<script>
import LogoBar from "./components/LogoBar";
import {mapActions, mapMutations} from "vuex";

export default {
	name: 'App',
	components: {LogoBar},
	created() {
		this.$router.options.base = this.$config.BASE_URL;
		this.setApiBaseUrl(this.$config.API_BASE_URL);
		document.addEventListener("resume", this.onResume, false);

		this.onResume();
	},
	methods: {
		...mapActions({
			updateAuthToken: "Api/updateAuthToken",
			fetchUserDetails: "Api/Users/get",
			refreshBottles: "Api/Bottles/all"
		}),
		...mapMutations({
			setApiBaseUrl: "Api/setApiBaseUrl"
		}),
		async onResume() {
			console.log("welcome back! run onResume =>");
			let token = window.localStorage.getItem(process.env.VUE_APP_AUTH_TOKEN_STORAGE_KEY);
			try {
				await this.updateAuthToken(token);
				this.fetchUserDetails({id: "self"})
					.catch(this.apiErrorHandler)

				// if (this.$router.currentRoute.path === "/") {
				// 	this.$router.push(window.AppConfig.isAdminPanel ? '/admin' : '/home').catch(console.log);
				// }

			} catch (e) {
				if (!this.$config.PUBLIC_ACCESS) {
					if (!this.$router.currentRoute.path.match(/(enroll)|(reset_password)|(login)|(config)/gi)) {
						this.$router
							.push('/')
							.catch(() => null)
					}
				}
				return console.log(e)

			}
		}
	}
}

</script>

<style lang="scss">
$fa-font-path: "./assets/fonts";
$img-path: "./assets/img";
@import "~cssteudter-bootstrap-theme/scss/main";
</style>
